import React from "react";

const HeadingDivider = () => {
  return (
    <div className="flex justify-center py-8">
      <div className="border-t-4 border-blue-600 w-32"></div>
      <div className="border-t-4 border-stone-600 w-24"></div>
    </div>
  );
};

export default HeadingDivider;
